/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowsSort = createReactComponent("arrows-sort", "IconArrowsSort", [
  ["path", { d: "M3 9l4 -4l4 4m-4 -4v14", key: "svg-0" }],
  ["path", { d: "M21 15l-4 4l-4 -4m4 4v-14", key: "svg-1" }]
]);

export { IconArrowsSort as default };
//# sourceMappingURL=IconArrowsSort.js.map
